import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  list: [],
  // 选中的地址信息
  selectedAddress: {}
};

export default function addressList(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取收货地址列表
    case ACTION_TYPES.GET_ADDRESS_LIST:
      result.list = payload;
      break;
    // 设置选中的地址信息
    case ACTION_TYPES.SET_SELECTED_ADDRESS:
      result.selectedAddress = payload;
      break;
    // 清除选中的地址信息
    case ACTION_TYPES.CLEAR_ORDER_CONFIRM_INFO:
    case ACTION_TYPES.CLEAR_SELECTED_ADDRESS:
      result.selectedAddress = INIT_STATE.selectedAddress;
      break;
    default:
      result = state;
  }
  return result;
}
